import { pushCallForHelpEvent } from '../../../domain/combat/structureCallForHelp.js';
import { cullWindWallBlockedProjectiles } from './projectileWindWallCull.js';

/**
 * 3D tick path: advance projectiles, sync meshes, remove hits.
 * (Distinct from legacy 2D `projectileSystem.updateProjectiles`.)
 */
export function updateTickProjectiles({
  activeProjectiles = [],
  allDamageableTargets = [],
  bushZones,
  dt = 0,
  recentDamageEvents = null,
  scene = null,
  gameTime = 0
} = {}) {
  cullWindWallBlockedProjectiles(
    activeProjectiles,
    allDamageableTargets,
    gameTime,
    scene
  );
  for (let i = activeProjectiles.length - 1; i >= 0; i--) {
    const p = activeProjectiles[i];
    const hasHit = p.domain.updatePosition(dt, allDamageableTargets, bushZones);
    if (p.mesh) {
      p.mesh.position.set(p.domain.x, p.domain.y, p.domain.z);
      p.mesh.rotation.y = p.domain.facingAngle;
    }
    if (!hasHit) continue;
    if (typeof p.onHit === 'function') p.onHit(p);
    pushCallForHelpEvent(
      recentDamageEvents,
      p.domain.sourceEntity,
      p.domain.lastHitEntity || p.domain.targetEntity
    );
    if (p.mesh && scene) scene.remove(p.mesh);
    activeProjectiles.splice(i, 1);
  }
}
